const PREFIX = "/reducer/basicConfig/";

export const SET_MOBILE_VIEW = `${PREFIX}SET_MOBILE_VIEW`;
export const IS_LOADING = `${PREFIX}IS_LOADING`;